import React from "react";
import { colors } from "../../../../../shared/constants";
import { Accordion } from "../../../../Accordion";
import MenuBadge from "../../../DesktopMenu/DesktopMenuDrawers/MenuBadge";
import { concatUrl } from "../../../helpers";
import * as S from "../../styles";
export default function ShopContent(_ref) {
  var e = _ref.topLevelLinks,
      l = _ref.handleLinkClick,
      t = _ref.handleFilteredPipLinkClick,
      a = _ref.renderLinkAs,
      r = _ref.productCategories,
      o = _ref.root,
      i = _ref.setOpen,
      n = _ref.hasPartialPipLoad,
      c = _ref.onMenuCardClick;
  var d, s, u;

  var m = function m(e) {
    return React.createElement(S.ShopAllFilteredPipButton, {
      "data-testid": "Shop All Button - ".concat(e.categoryName),
      href: concatUrl(e.url, o),
      onClick: function onClick() {
        return t(e);
      },
      as: a && n ? a : void 0
    }, "Shop all ".concat(e.categoryName));
  };

  return React.createElement(React.Fragment, null, e.shopAll ? React.createElement(S.MenuItem, {
    href: e.shopAll.url,
    "data-testid": "mobile-shop-all-link",
    onClick: function onClick() {
      var t;
      e && e.shopAll && e.shopAll.label && l(null === (t = null == e ? void 0 : e.shopAll) || void 0 === t ? void 0 : t.label), i(!1);
    },
    as: a || void 0
  }, e.shopAll.label) : null, e.giftGuide && React.createElement(S.LinksWrapper, null, React.createElement(S.MenuItem, {
    href: e.giftGuide.url,
    "data-testid": "mobile-giftGuide-link",
    onClick: function onClick() {
      var t;
      l((null === (t = e.giftGuide) || void 0 === t ? void 0 : t.label) || ""), i(!1);
    },
    as: a || void 0
  }, null === (d = e.giftGuide) || void 0 === d ? void 0 : d.label, (null === (s = e.giftGuide) || void 0 === s ? void 0 : s.displayBadge) && React.createElement(MenuBadge, {
    text: null === (u = e.giftGuide) || void 0 === u ? void 0 : u.badgeText,
    backgroundColor: colors.teal4
  }))), React.createElement(Accordion.Wrapper, null, r.map(function (e, t) {
    return function (e, t) {
      var r = e.productLinks,
          i = e.badge,
          n = e.filteredPipLink,
          d = e.card,
          s = function s(r) {
        return r.map(function (_ref2, d) {
          var r = _ref2.label,
              i = _ref2.url,
              n = _ref2.slug,
              c = _ref2.badge;
          return React.createElement(S.MenuItem, {
            key: "".concat(n, "-").concat(d),
            "data-testid": "".concat(n, "-").concat(t),
            onClick: function onClick() {
              return l("".concat(e.displayName, " - ").concat(r));
            },
            href: concatUrl(i, o),
            as: a || void 0
          }, r, c ? React.createElement(MenuBadge, {
            text: c,
            backgroundColor: colors.teal4
          }) : null);
        });
      };

      return React.createElement(S.AccordionItem, {
        key: "mobile - ".concat(e.slug)
      }, React.createElement(S.AccordionHeading, {
        dataTestId: "mobile-shop-category-".concat(e.slug),
        onClick: function onClick() {
          return l(e.displayName);
        }
      }, React.createElement("div", null, e.displayName, i ? React.createElement(MenuBadge, {
        text: i,
        backgroundColor: colors.teal4
      }) : null)), Array.isArray(r) && r.length > 0 ? React.createElement(S.AccordionChild, null, s(r), n ? m(n) : null) : Object.keys(r).map(function (e) {
        return React.createElement(S.AccordionChild, {
          key: e
        }, React.createElement(S.AccordionChildSubHeader, null, e), s(r[e]), n ? m(n) : null);
      }), React.createElement(S.PromoCardsAccordionChild, {
        dataTestId: "nutritional-mobile-cards",
        hasTopMargin: Array.isArray(r) && 0 === r.length
      }, React.createElement(S.ProductCard, Object.assign({
        key: null == d ? void 0 : d.slug
      }, d, {
        onClick: c
      }))));
    }(e, t);
  })), React.createElement(S.LinksWrapper, null, e.giftCards ? React.createElement(S.MenuItem, {
    href: e.giftCards.url,
    "data-testid": "mobile-gift-cards-link",
    onClick: function onClick() {
      var t;
      e && e.giftCards && e.giftCards.label && l(null === (t = null == e ? void 0 : e.giftCards) || void 0 === t ? void 0 : t.label), i(!1);
    },
    as: a || void 0
  }, e.giftCards.label) : null));
}